import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

export const CloudDoneIcon = (props: SVGProps): JSX.Element => {
  const { title = 'CloudDone', className, ...restProps } = props;

  return (
    <svg
      className={cn('fill-current', className)}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <title>{title}</title>
      <path d="M38.71 20.07C37.35 13.19 31.28 8 24 8C18.22 8 13.21 11.28 10.7 16.07C4.69 16.72 0 21.81 0 28C0 34.63 5.37 40 12 40H38C43.52 40 48 35.52 48 30C48 24.72 43.89 20.44 38.71 20.07ZM20 34L13 27L15.83 24.17L20 28.34L30.35 17.99L33.18 20.82L20 34Z" />
    </svg>
  );
};
